import { render, staticRenderFns } from "./TableCellComment.vue?vue&type=template&id=199c69ce&"
import script from "./TableCellComment.vue?vue&type=script&lang=ts&"
export * from "./TableCellComment.vue?vue&type=script&lang=ts&"
import style0 from "./TableCellComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports